import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { EmailService, EnrichedMessage } from '../email.service';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { PopupService } from '@app/core/services/popup.service';
import { FormButton } from '@app/core/components/form-field-button/form-field-button.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';

@Component({
    selector: 'tt-email-person-info-form',
    templateUrl: './email-person-info-form.component.html',
    styleUrls: ['./email-person-info-form.component.css'],
})
export class EmailPersonInfoFormComponent implements OnChanges {
    @Input()
    public email?: EnrichedMessage;

    @Output()
    public submit = new EventEmitter<EmailPersonSaveResponse>();

    public fromPersons: Item[] = [];

    public fromCustomerFormButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'customersmenu', gotoParms: () => ({ cust_no: '' + this.email!.from_cust_no }) }];

    public fromCustomerEmptyFormButtons: FormButton[] = [{ id: 'create', type: 'primary', icon: 'fas fa-plus', onClick: () => this.openCustomerEditPopup() }];

    public saving = false;

    constructor(private emailService: EmailService, private datatask: DataTaskService, private modal: ModalService, private popup: PopupService) {}

    public searchFromCustomer = () => this.emailService.searchAllCustomer(this.email!.from_cust_name);

    private async openCustomerEditPopup() {
        const data = await this.popup.openPopup('customeredit/0', { rememberId: 'emailarchiveform' });

        window.addEventListener('message', this.setDataFromMessage);

        data?.closed.subscribe({
            next: (value) => {
                if (value) {
                    window.removeEventListener('message', this.setDataFromMessage);
                }
            },
        });
    }

    private setDataFromMessage = (event: MessageEvent<any>) => {
        if (Object.hasOwn(event.data, 'type') && event.data.type === 'ttData') {
            const data: { cust_no: string; cust_name: string } = event.data.data;

            if (typeof data === 'object' && 'cust_no' in data && 'cust_name' in data && !!data.cust_no && data.cust_name) {
                this.onFromCustomerSelected({ item_id: data.cust_no, item_name: data.cust_name });
            }

            window.removeEventListener('message', this.setDataFromMessage);
        }
    };

    public onFromCustomerSelected(item?: Item) {
        if (!!this.email) {
            if (!item || this.email.from_cust_no != item?.item_id) {
                this.email.from_cust_no = '0';
                this.email.from_cust_name = '';
                this.fromPersons = [];
                this.email.pers_name = '0';
                this.email.pers_no = '0';
            }

            this.email.from_cust_name = item?.item_name ?? '';
            this.email.from_cust_no = item?.item_id ?? '0';

            if (this.email.from_cust_no > '0') {
                this.loadFromPersons();
            }
            if (this.email.from_cust_no > '0' && this.email.cust_no == '0') {
                // this.onCustomerSelected({ item_id: this.email.from_cust_no, item_name: this.email.from_cust_name });
            }
        }
    }

    private async loadFromPersons() {
        if (this.email?.from_cust_no) {
            this.fromPersons = await this.emailService.getCustomerPersons(this.email.from_cust_no);
        }
    }

    public async saveChanges() {
        if (!!this.email) {
            try {
                this.saving = true;

                const response: EmailPersonSaveResponse = (await this.datatask.Post(3867, this.email))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage,
                    });
                } else {
                    this.submit.emit(response);
                }
            } finally {
                this.saving = false;
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes?.['email']?.currentValue && changes['email'].currentValue !== changes['email'].previousValue) {
            if (!!this.email) {
                this.email.pers_no = '' + this.email.pers_no;
            }

            this.fromPersons = [];

            if (!!this.email && this.email.from_cust_no > '0') {
                this.loadFromPersons();
            }
        }
    }
}

export interface EmailPersonSaveResponse extends ErrorMessageResponse {
    pers_no: string | number;
}
